module.exports = __webpack_public_path__ + "img/mobile-data-grey24.b155cc64.svg";